'use client'
import {
  NotifyButton_default
} from "./chunk-57OV3DOS.mjs";
import {
  CollapsableText_default
} from "./chunk-C6ORFFFA.mjs";
import {
  ShareContentfulButton_default
} from "./chunk-K6KAH2OE.mjs";
import {
  DecoratedSection_default
} from "./chunk-B3BBH7CB.mjs";
import {
  ContentfulButton_default
} from "./chunk-A5EHVVY6.mjs";
import {
  ContentfulMedia_default
} from "./chunk-QX2PWGVG.mjs";

// src/components/hero/HeroSection.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var HeroSection = ({ section }) => {
  const card = section.contentCollection.items[0];
  if (!card)
    return null;
  const desktopImage = card.image31 || card.background;
  const mobileImage = card.image11 || card.background;
  return /* @__PURE__ */ jsx("section", { id: section.id, children: /* @__PURE__ */ jsxs("div", { className: "from-body/60 to-body relative flex min-h-screen flex-col justify-between from-10% via-transparent via-20% before:absolute before:inset-0 before:-z-10 before:bg-gradient-to-b", children: [
    desktopImage && /* @__PURE__ */ jsx(
      ContentfulMedia_default,
      {
        media: desktopImage,
        poster: desktopImage == null ? void 0 : desktopImage.url,
        className: "absolute -z-20 hidden h-full w-full object-cover sm:block",
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        ratio: "3x1",
        placeholder: true
      }
    ),
    mobileImage && /* @__PURE__ */ jsx(
      ContentfulMedia_default,
      {
        media: mobileImage,
        poster: mobileImage == null ? void 0 : mobileImage.url,
        className: "absolute -z-20 h-full w-full object-cover sm:hidden",
        ratio: "1x1",
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        placeholder: true
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "container flex min-h-[calc(100vh-100px)] flex-col items-start justify-end gap-10 pb-20 lg:flex-row lg:items-end lg:justify-between", children: [
      /* @__PURE__ */ jsxs("div", { className: "w-full max-w-3xl space-y-2 pt-32 sm:pt-0", children: [
        card.icon && /* @__PURE__ */ jsx("div", { className: "shrink-0 pb-2", children: /* @__PURE__ */ jsx(
          ContentfulMedia_default,
          {
            media: card.icon,
            width: 100,
            height: 100,
            className: "object-contain"
          }
        ) }),
        /* @__PURE__ */ jsx("h1", { className: "text-4xl lg:flex-1 lg:text-7xl", children: card.title }),
        card.subtitle && /* @__PURE__ */ jsx("p", { className: "text-lg font-semibold lg:text-xl", children: card.subtitle }),
        card.description && /* @__PURE__ */ jsx(CollapsableText_default, { text: card.description, className: "text-sm" })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "flex flex-wrap items-center gap-2 text-sm md:gap-5 md:text-base lg:flex-1 lg:justify-end", children: section.webLinksCollection.items.map((link) => /* @__PURE__ */ jsx(ContentfulButton_default, { link, phill: true }, link.id)) })
    ] })
  ] }) });
};
var HeroSection_default = HeroSection;

// src/components/hero/HeroCounter.tsx
import { Typography } from "@wbk/ui";

// src/components/hero/Countdown.tsx
import { useId } from "react";
import { useCountDown } from "@wbk/hooks";
import { useTranslation } from "@wbk/config";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var NOW_SECONDS = (/* @__PURE__ */ new Date()).getTime() / 1e3;
var HeroCountdown = ({ finishDate, mini = false }) => {
  const { t } = useTranslation("contentful_common");
  const id = useId();
  const { timer, isTimeUp } = useCountDown({
    id,
    initialSeconds: new Date(finishDate).getTime() / 1e3 - NOW_SECONDS
  });
  if (isTimeUp) {
    return null;
  }
  if (mini) {
    return `${timer.days}D:${timer.hours}H:${timer.minutes}M:${timer.seconds}S`;
  }
  return /* @__PURE__ */ jsxs2("div", { className: "mx-auto flex max-w-sm justify-center gap-4 text-center", children: [
    /* @__PURE__ */ jsxs2("div", { className: "bg-text/10 grow rounded-md px-4 py-2", children: [
      /* @__PURE__ */ jsx2("p", { className: "font-sans text-3xl font-bold", children: timer.days }),
      /* @__PURE__ */ jsx2("p", { className: "text-text-secondary text-sm", children: t("contentful_common:timer.days") })
    ] }),
    /* @__PURE__ */ jsxs2("div", { className: "bg-text/10 grow rounded-md px-4 py-2", children: [
      /* @__PURE__ */ jsx2("p", { className: "font-sans text-3xl font-bold", children: timer.hours }),
      /* @__PURE__ */ jsx2("p", { className: "text-text-secondary text-sm", children: t("contentful_common:timer.hours") })
    ] }),
    /* @__PURE__ */ jsxs2("div", { className: "bg-text/10 grow rounded-md px-4 py-2", children: [
      /* @__PURE__ */ jsx2("p", { className: "font-sans text-3xl font-bold", children: timer.minutes }),
      /* @__PURE__ */ jsx2("p", { className: "text-text-secondary text-sm", children: t("contentful_common:timer.minutes") })
    ] }),
    /* @__PURE__ */ jsxs2("div", { className: "bg-text/10 grow rounded-md px-4 py-2", children: [
      /* @__PURE__ */ jsx2("p", { className: "font-sans text-3xl font-bold", children: timer.seconds }),
      /* @__PURE__ */ jsx2("p", { className: "text-text-secondary text-sm", children: t("contentful_common:timer.seconds") })
    ] })
  ] });
};
var Countdown_default = HeroCountdown;

// src/components/hero/HeroCounter.tsx
import { Fragment, jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var HeroCounterSection = ({ section }) => {
  var _a, _b;
  const item = (_a = section.contentCollection.items) == null ? void 0 : _a[0];
  const title = (item == null ? void 0 : item.title) || section.title;
  const subtitle = (item == null ? void 0 : item.subtitle) || section.subtitle;
  const logo = (item == null ? void 0 : item.eventLogo) || section.logo;
  const startAt = (_b = item == null ? void 0 : item.schedule) == null ? void 0 : _b.openDateTime;
  const started = !startAt || new Date(startAt) < /* @__PURE__ */ new Date();
  return /* @__PURE__ */ jsx3(DecoratedSection_default, { section, className: "overflow-hidden", children: /* @__PURE__ */ jsxs3("div", { className: "container relative z-10 space-y-6 text-center", children: [
    logo && /* @__PURE__ */ jsx3(ContentfulMedia_default, { media: logo, className: "mx-auto" }),
    /* @__PURE__ */ jsxs3("div", { className: "space-y-2", children: [
      /* @__PURE__ */ jsx3(Typography, { as: "h1", variant: "display-M", children: title }),
      subtitle && /* @__PURE__ */ jsx3(Typography, { children: subtitle })
    ] }),
    !started && /* @__PURE__ */ jsxs3(Fragment, { children: [
      /* @__PURE__ */ jsx3(Countdown_default, { finishDate: startAt }),
      /* @__PURE__ */ jsx3(NotifyButton_default, { event: item, className: "min-h-0 max-w-sm py-3" })
    ] })
  ] }) });
};
var HeroCounter_default = HeroCounterSection;

// src/components/hero/HeroGrid.tsx
import { Typography as Typography2 } from "@wbk/ui";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var HeroGrid = ({ section }) => {
  var _a, _b, _c;
  const card = (_b = (_a = section.contentCollection) == null ? void 0 : _a.items) == null ? void 0 : _b[0];
  const links = (_c = section.webLinksCollection) == null ? void 0 : _c.items;
  if (!card)
    return null;
  return /* @__PURE__ */ jsx4(DecoratedSection_default, { section, children: /* @__PURE__ */ jsxs4("div", { className: "container flex min-h-96 w-full flex-col-reverse items-center justify-center gap-8 lg:flex-row", children: [
    /* @__PURE__ */ jsxs4("div", { className: "grow space-y-4 py-6", children: [
      section.logo && /* @__PURE__ */ jsx4(ContentfulMedia_default, { media: section.logo }),
      /* @__PURE__ */ jsx4(Typography2, { variant: "heading-XL", children: card.title }),
      card.subtitle && /* @__PURE__ */ jsx4(Typography2, { variant: "body-L", children: card.subtitle }),
      !!links.length && /* @__PURE__ */ jsx4("ul", { className: "flex flex-wrap items-center gap-2", children: links.map((link) => /* @__PURE__ */ jsx4(ContentfulButton_default, { link }, link.id)) })
    ] }),
    (card == null ? void 0 : card.image) && /* @__PURE__ */ jsx4("div", { className: "shrink", children: /* @__PURE__ */ jsx4(ContentfulMedia_default, { media: card.image, className: "w-full max-w-full" }) })
  ] }) });
};
var HeroGrid_default = HeroGrid;

// src/components/hero/HeroImage.tsx
import { useMemo, useState } from "react";
import { Button, Carousel, Typography as Typography3 } from "@wbk/ui";
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var HeroImage = ({ section }) => {
  var _a;
  const cards = section.contentCollection.items;
  const tags = section.tagsCollection.items;
  const [selectedTag, setSelectedTag] = useState((_a = tags == null ? void 0 : tags[0]) != null ? _a : null);
  const card = useMemo(() => {
    if (!(cards == null ? void 0 : cards.length))
      return null;
    if (!tags.length)
      return cards[0];
    return cards.find(
      (card2) => {
        var _a2, _b;
        return (_b = (_a2 = card2.cmsTagsCollection) == null ? void 0 : _a2.items) == null ? void 0 : _b.find((tag) => tag.id === (selectedTag == null ? void 0 : selectedTag.id));
      }
    );
  }, [cards, selectedTag, tags.length]);
  if (!card)
    return null;
  const desktopImage = card.image31 || card.background;
  const mobileImage = card.image11 || card.background;
  return /* @__PURE__ */ jsxs5(DecoratedSection_default, { section, className: (tags == null ? void 0 : tags.length) ? "container" : "", children: [
    !!(tags == null ? void 0 : tags.length) && /* @__PURE__ */ jsx5(
      Carousel,
      {
        title: /* @__PURE__ */ jsx5(Typography3, { variant: "heading-L", children: section.title }),
        className: "pb-L",
        children: tags == null ? void 0 : tags.map((tagItem) => /* @__PURE__ */ jsx5(
          Button,
          {
            shape: "outlined",
            theme: "action",
            onClick: () => setSelectedTag(tagItem),
            "data-active": (selectedTag == null ? void 0 : selectedTag.id) === tagItem.id,
            className: "ltr:mr-S rtl:ml-S data-[active=false]:border-action/20 data-[active=false]:text-action/50 shrink-0",
            children: /* @__PURE__ */ jsx5(Typography3, { variant: "label-M", children: tagItem.title })
          },
          tagItem.id
        ))
      }
    ),
    desktopImage && /* @__PURE__ */ jsx5(
      ContentfulMedia_default,
      {
        media: desktopImage,
        poster: desktopImage == null ? void 0 : desktopImage.url,
        className: "hidden h-full w-full object-cover sm:block",
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        ratio: "3x1",
        placeholder: true
      }
    ),
    mobileImage && /* @__PURE__ */ jsx5(
      ContentfulMedia_default,
      {
        media: mobileImage,
        poster: mobileImage == null ? void 0 : mobileImage.url,
        className: "h-full w-full object-cover sm:hidden",
        ratio: "1x1",
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        placeholder: true
      }
    )
  ] });
};
var HeroImage_default = HeroImage;

// src/components/hero/HeroLogo.tsx
import { Typography as Typography4 } from "@wbk/ui";
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var HeroLogo = ({ section }) => {
  const card = section.contentCollection.items[0];
  const logo = section.logo;
  const otherLinks = section.webLinksCollection.items.filter((link) => link.id !== "share");
  if (!card || !logo)
    return null;
  const desktopImage = card.image31 || card.background;
  const mobileImage = card.image11 || card.background;
  return /* @__PURE__ */ jsx6(DecoratedSection_default, { section, children: /* @__PURE__ */ jsxs6("div", { className: "relative", children: [
    desktopImage && /* @__PURE__ */ jsx6(
      ContentfulMedia_default,
      {
        className: "relative inset-0 hidden aspect-[4/1] w-full object-cover md:block",
        media: desktopImage,
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        ratio: "3x1",
        placeholder: true
      }
    ),
    mobileImage && /* @__PURE__ */ jsx6(
      ContentfulMedia_default,
      {
        className: "relative inset-0 block max-h-[450px] w-full object-cover md:hidden",
        media: mobileImage,
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        ratio: "1x1",
        placeholder: true
      }
    ),
    /* @__PURE__ */ jsx6(ShareContentfulButton_default, { section, type: "mini", className: "md:hidden" }),
    /* @__PURE__ */ jsxs6("div", { className: "rounded-t-L bg-body gap-L md:py-L container relative -mt-4 flex flex-col items-center justify-center md:mt-0 md:flex-row md:items-start md:justify-between md:bg-transparent", children: [
      /* @__PURE__ */ jsx6(
        ContentfulMedia_default,
        {
          media: logo,
          alt: logo == null ? void 0 : logo.title,
          width: logo == null ? void 0 : logo.width,
          height: logo == null ? void 0 : logo.height,
          className: "absolute top-0 h-24 w-24 shrink-0 -translate-y-1/2 rounded-full object-contain md:h-48 md:w-48 md:ltr:left-8 md:rtl:right-8"
        }
      ),
      /* @__PURE__ */ jsx6("div", { className: "hidden shrink-0 md:block md:h-24 md:w-48" }),
      /* @__PURE__ */ jsxs6("div", { className: "gap-L flex w-full flex-col items-center justify-between pt-16 md:flex-row md:items-start md:py-0", children: [
        /* @__PURE__ */ jsxs6("div", { className: "space-y-XS w-full text-center md:max-w-md md:text-start lg:max-w-2xl", children: [
          /* @__PURE__ */ jsx6(Typography4, { strong: true, variant: "heading-XXL", children: section.title }),
          /* @__PURE__ */ jsxs6(Typography4, { strong: true, color: "text-secondary", children: [
            section.subtitle,
            (card == null ? void 0 : card.expiresAt) && /* @__PURE__ */ jsx6("span", { className: "mx-1", children: /* @__PURE__ */ jsx6(Countdown_default, { finishDate: card.expiresAt, mini: true }) })
          ] })
        ] }),
        /* @__PURE__ */ jsx6("div", { className: "flex gap-4", children: /* @__PURE__ */ jsxs6("div", { className: "flex flex-wrap items-center justify-end gap-2 text-sm md:gap-5 md:text-base lg:flex-1 lg:justify-end", children: [
          otherLinks.map((link) => /* @__PURE__ */ jsx6(ContentfulButton_default, { link }, link.id)),
          /* @__PURE__ */ jsx6(
            ShareContentfulButton_default,
            {
              section,
              className: "gap-XS hidden border-opacity-10 md:flex"
            }
          )
        ] }) })
      ] })
    ] })
  ] }) });
};
var HeroLogo_default = HeroLogo;

// src/components/hero/HeroLeftCounter.tsx
import { Typography as Typography5 } from "@wbk/ui";
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var HeroLeftCounterSection = ({ section }) => {
  var _a, _b, _c;
  const card = (_a = section.contentCollection.items) == null ? void 0 : _a[0];
  if (!card)
    return null;
  const title = card == null ? void 0 : card.title;
  const subtitle = card == null ? void 0 : card.subtitle;
  const logo = card == null ? void 0 : card.image;
  const expiresAt = card == null ? void 0 : card.expiresAt;
  const expired = expiresAt && new Date(expiresAt) < /* @__PURE__ */ new Date();
  const webLinks = (_c = (_b = section == null ? void 0 : section.webLinksCollection) == null ? void 0 : _b.items) == null ? void 0 : _c.filter((link) => link.id !== "share");
  const claimer = card == null ? void 0 : card.description;
  return /* @__PURE__ */ jsx7(DecoratedSection_default, { section, className: "overflow-hidden", children: /* @__PURE__ */ jsxs7("div", { className: "container relative z-10 flex flex-col items-start space-y-6", children: [
    /* @__PURE__ */ jsx7(ShareContentfulButton_default, { section, type: "mini", className: "md:hidden" }),
    logo && /* @__PURE__ */ jsx7(ContentfulMedia_default, { media: logo }),
    /* @__PURE__ */ jsxs7("div", { className: "space-y-2", children: [
      /* @__PURE__ */ jsx7(Typography5, { as: "h1", variant: "display-M", children: title }),
      subtitle && /* @__PURE__ */ jsx7(Typography5, { children: subtitle })
    ] }),
    expiresAt && !expired && /* @__PURE__ */ jsxs7("div", { className: "space-y-2", children: [
      card.buttonLabel && /* @__PURE__ */ jsx7(Typography5, { variant: "body-L", color: "text-secondary", children: card.buttonLabel }),
      /* @__PURE__ */ jsx7(Countdown_default, { finishDate: expiresAt })
    ] }),
    !!(webLinks == null ? void 0 : webLinks.length) && /* @__PURE__ */ jsxs7("div", { className: "flex w-full flex-wrap items-center gap-4", children: [
      webLinks.map((link) => /* @__PURE__ */ jsx7(
        ContentfulButton_default,
        {
          link,
          className: "min-h-[52px] w-full sm:max-w-[340px]"
        },
        link.id
      )),
      /* @__PURE__ */ jsx7(
        ShareContentfulButton_default,
        {
          section,
          className: "hidden min-h-[52px] w-full sm:max-w-[340px] md:flex"
        }
      )
    ] }),
    claimer && /* @__PURE__ */ jsx7(Typography5, { variant: "label-M", children: claimer })
  ] }) });
};
var HeroLeftCounter_default = HeroLeftCounterSection;

export {
  HeroSection_default,
  HeroCounter_default,
  HeroGrid_default,
  HeroImage_default,
  HeroLogo_default,
  HeroLeftCounter_default
};
//# sourceMappingURL=chunk-V3WMT6NP.mjs.map